module.exports = __webpack_public_path__ + "static/media/low_battery.91bf0221.svg";